import { render, staticRenderFns } from "./Part4Layout.vue?vue&type=template&id=1aab3558&scoped=true"
import script from "./Part4Layout.vue?vue&type=script&lang=ts"
export * from "./Part4Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=1aab3558&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aab3558",
  null
  
)

export default component.exports